module.exports = __webpack_public_path__ + "media/images/front/treatment_support/title_appeal-46260df2e8e05ccf47ab3841f16eaa91.png";